import type { PropsWithChildren } from 'react';

import { Loader } from '@/components/Loader';
import { useRouter } from '@/hooks/useRouter';
import { useUser } from '@/hooks/useUser';

export const Initializer = ({
  children,
  emailVerification,
}: PropsWithChildren<{ emailVerification?: string }>) => {
  const {
    snapshot: { user },
  } = useUser();
  const { replace } = useRouter();

  if (emailVerification && user?.email !== emailVerification) {
    replace('/');
    return <Loader data-testid='InitializerLoader' height={400} />;
  }

  return <div data-testid='Initializer'>{children}</div>;
};
